<template src="./History.html"></template>
<script>
export default {
  name: "history",
  props: ["patientId"],
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      showWebTable: true,
      histories: [],
      idMedicalRecord: 0,
      isNewAppointment: false,
      openNewWindow: false,
      showBackButton: false,
    };
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  mounted: function() {
    const vm = this;
    if(vm.$route.name === "pages-doctor"){
      vm.showBackButton = false;
    }
    else {
      vm.showBackButton = true;
    }
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      let url = window.location.href;

      var idPatient = vm.$props.patientId;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "doctor/my-patients/" +
            idPatient +
            "?page=0&size=10&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") },
            options: {
              page: 0,
              size: 20,
              sort: ["id", "desc"]
            }
          }
        )
        .then(function(response) {
          vm.histories = response.data.content;
          if (url.indexOf("patient-data") == -1) {
            for (let h in vm.histories) {
              vm.histories[h].openNewWindow = false;
            }
          } else {
            for (let h in vm.histories) {
              vm.histories[h].openNewWindow = true;
            }
          }
        });
    },
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width < 1100) {
        vm.showWebTable = false;
      } else {
        vm.showWebTable = true;
      }
    },
    showPagePatientAttendance() {
      const vm = this;
      vm.$emit("showPagePatientAttendance", event);
    },
  }
};
</script>
<style lang="scss" src="./History.scss">
</style>